import { RouteConfig } from "vue-router";

// ログインページ
import LoginPage from "@/pages/LoginPage.vue";
// パスワード編集画面
import PasswordsEditPage from "@/pages/password/PasswordsEditPage.vue";
// パスワード忘れ画面
import PasswordsForgetPage from "@/pages/password/PasswordsForgetPage.vue";
// パスワード仮発行画面
import PasswordsIssuePage from "@/pages/password/PasswordsIssuePage.vue";
// ダッシュボード TOP 画面
import DashboardPage from "@/pages/DashboardPage.vue";
// 温度管理画面イメージ画面
import TempManagementsImagePage from "@/pages/temp_managements/TempManagementsImagePage.vue";
// 温度管理画面リスト画面
import TempManagementsListPage from "@/pages/temp_managements/TempManagementsListPage.vue";
// センサ配置図画面
import SensorDiagramsShowPage from "@/pages/sensor_diagrams/SensorDiagramsShowPage.vue";
// センサ配置図編集画面
import SensorDiagramsEditPage from "@/pages/sensor_diagrams/SensorDiagramsEditPage.vue";
// 温度グラフ画面
import TempGraphsPage from "@/pages/TempGraphsPage.vue";
// 警報履歴一覧画面
import WarningHistoriesPage from "@/pages/WarningHistoriesPage.vue";
// マスタ管理
import MasterManagementsPage from "@/pages/MasterManagementsPage.vue";
// 新規店舗追加画面
import StoreInfosCreatePage from "@/pages/store_infos/StoreInfosCreatePage.vue";
// 店舗情報編集画面
import StoreInfosEditPage from "@/pages/store_infos/StoreInfosEditPage.vue";
// 新規ユーザー登録
import UsersCreatePage from "@/pages/users/UsersCreatePage.vue";
// ユーザー情報編集画面
import UsersEditPage from "@/pages/users/UsersEditPage.vue";
// お知らせ作成
import NotificationsCreatePage from "@/pages/notifications/NotificationsCreatePage.vue";
// レポート一覧画面
import ReportsShowPage from "@/pages/reports/ReportsShowPage.vue";
// レポート作成画面
import ReportsCreatePage from "@/pages/reports/ReportsCreatePage.vue";
// 定期レポート編集画面
import RegularReportsEditPage from "@/pages/reports/RegularReportsEditPage.vue";
// センサ情報画面
import SensorsShowPage from "@/pages/sensors/SensorsShowPage.vue";
// センサ情報編集画面
import SensorsEditPage from "@/pages/sensors/SensorsEditPage.vue";
// 店舗グループマスタ画面
import StoreGroupMasterShowPage from "@/pages/store_groups/StoreGroupMasterShowPage.vue";
// 店舗グループマスタ新規作成画面
import StoreGroupMasterCreatePage from "@/pages/store_groups/StoreGroupMasterCreatePage.vue";
// 店舗グループマスタ編集画面
import StoreGroupMasterEditPage from "@/pages/store_groups/StoreGroupMasterEditPage.vue";
// 会社マスタ画面
import CompanyMasterShowPage from "@/pages/companies/CompanyMasterShowPage.vue";
// 会社マスタ新規作成画面
import CompanyMasterCreatePage from "@/pages/companies/CompanyMasterCreatePage.vue";
// 会社マスタ編集画面
import CompanyMasterEditPage from "@/pages/companies/CompanyMasterEditPage.vue";
// ユーザーグループマスタ画面
import UserGroupMasterShowPage from "@/pages/user_groups/UserGroupMasterShowPage.vue";
// ユーザーグループマスタ新規作成画面
import UserGroupMasterCreatePage from "@/pages/user_groups/UserGroupMasterCreatePage.vue";
// ユーザーグループマスタ編集画面
import UserGroupMasterEditPage from "@/pages/user_groups/UserGroupMasterEditPage.vue";
// ユーザーマスタ画面
import UserMasterShowPage from "@/pages/users/UserMasterShowPage.vue";
// ユーザーマスタ新規作成画面
import UserMasterCreatePage from "@/pages/users/UserMasterCreatePage.vue";
// ユーザーマスタ編集画面
import UserMasterEditPage from "@/pages/users/UserMasterEditPage.vue";
// 警報停止時間帯一覧画面
import WarningStopTimeShowPage from "@/pages/warning_stop_times/WarningStopTimeShowPage.vue";
// 警報停止時間帯編集・新規作成画面
import WarningStopTimeEditPage from "@/pages/warning_stop_times/WarningStopTimeEditPage.vue";
// 404 ページ
import NotFoundPage from "@/pages/NotFoundPage.vue";

// RouteConfig の wrapper type でページ名を key として保持し、外部からアクセス可能とする
export type RouteInfos = {
  [key: string]: RouteConfig;
};

// 各ページ、コンポーネントから参照するための変数
export const routeInfos: RouteInfos = {
  HomePage: {
    path: "/",
    name: "home",
    component: LoginPage
  },
  LoginPage: {
    path: "/login",
    name: "login-page",
    component: LoginPage,
    meta: {
      isPublic: true
    }
  },
  PasswordsEditPage: {
    path: "/passwords/edit",
    name: "passwords-edit-page",
    component: PasswordsEditPage
  },
  PasswordsForgetPage: {
    path: "/passwords/forget",
    name: "passwords-forget-page",
    component: PasswordsForgetPage,
    meta: {
      isPublic: true
    }
  },
  PasswordsIssuePage: {
    path: "/passwords/issue",
    name: "passwords-issue-page",
    component: PasswordsIssuePage,
    meta: {
      isPublic: true
    }
  },
  DashboardPage: {
    path: "/dashboard",
    name: "dashboard-page",
    component: DashboardPage
  },
  TempManagementsImagePage: {
    path: "/stores/:store_id/temp_managements_image",
    name: "temp-managements-image-page",
    component: TempManagementsImagePage
  },
  TempManagementsListPage: {
    path: "/stores/:store_id/temp_managements_list",
    name: "temp-managements-list-page",
    component: TempManagementsListPage
  },
  SensorDiagramsShowPage: {
    path: "/stores/:store_id/sensor_diagrams/show",
    name: "sensor-diagrams-show-page",
    component: SensorDiagramsShowPage
  },
  SensorDiagramsEditPage: {
    path: "/stores/:store_id/sensor_diagrams/edit",
    name: "sensor-diagrams-edit-page",
    component: SensorDiagramsEditPage
  },
  TempGraphsPage: {
    path: "/stores/:store_id/temp_graphs",
    name: "temp-graphs-page",
    component: TempGraphsPage
  },
  WarningHistoriesPage: {
    path: "/stores/:store_id/warning_histories",
    name: "warning-histories-page",
    component: WarningHistoriesPage
  },
  ReportsPage: {
    path: "/stores/:store_id/reports",
    name: "reports-show-page",
    component: ReportsShowPage
  },
  ReportsCreatePage: {
    path: "/stores/:store_id/reports/create",
    name: "reports-create-page",
    component: ReportsCreatePage
  },
  SettingsPage: {
    path: "/stores/:store_id/settings",
    name: "settings-page"
  },
  MasterManagementsPage: {
    path: "/stores/:store_id/master_managements",
    name: "master-managements-page",
    component: MasterManagementsPage
  },
  StoreInfosCreatePage: {
    path: "/stores/store_infos/create",
    name: "store-create-page",
    component: StoreInfosCreatePage
  },
  StoreInfosEditPage: {
    path: "/stores/:store_id/store_infos/edit",
    name: "store-infos-edit-page",
    component: StoreInfosEditPage
  },
  UsersCreatePage: {
    path: "/stores/:store_id/users/create",
    name: "users-create-page",
    component: UsersCreatePage
  },
  UsersEditPage: {
    path: "/stores/:store_id/users/:user_id/edit",
    name: "users-edit-page",
    component: UsersEditPage
  },
  NotificationsCreatePage: {
    path: "/notifications/create",
    name: "notifications-create-page",
    component: NotificationsCreatePage
  },
  RegularReportsEditPage: {
    path: "/stores/:store_id/regular_report/:report_id/edit",
    name: "regular-report-edit",
    component: RegularReportsEditPage
  },
  SensorsShowPage: {
    path: "/stores/:store_id/sensors/show",
    name: "sensors-show-page",
    component: SensorsShowPage
  },
  SensorsEditPage: {
    path: "/stores/:store_id/sensors/:sensor_id/edit",
    name: "sensors-edit-page",
    component: SensorsEditPage
  },
  StoreGroupMasterShowPage: {
    path: "/storegroup/master",
    name: "store-group-master-show-page",
    component: StoreGroupMasterShowPage
  },
  StoreGroupMasterCreatePage: {
    path: "/storegroup/master/create",
    name: "store-groups-master-create-page",
    component: StoreGroupMasterCreatePage
  },
  StoreGroupMasterEditPage: {
    path: "/storegroup/master/:storegroup_id/edit",
    name: "store-groups-master-edit-page",
    component: StoreGroupMasterEditPage
  },
  CompanyMasterShowPage: {
    path: "/company/master",
    name: "company-master-show-page",
    component: CompanyMasterShowPage
  },
  CompanyMasterCreatePage: {
    path: "/company/master/create",
    name: "company-master-create-page",
    component: CompanyMasterCreatePage
  },
  CompanyMasterEditPage: {
    path: "/company/master/:company_id/edit",
    name: "companies-master-edit-page",
    component: CompanyMasterEditPage
  },
  UserGroupMasterShowPage: {
    path: "/usergroup/master",
    name: "usergroup-master-show-page",
    component: UserGroupMasterShowPage
  },
  UserGroupMasterCreatePage: {
    path: "/usergroup/master/create",
    name: "usergroup-master-create-page",
    component: UserGroupMasterCreatePage
  },
  UserGroupMasterEditPage: {
    path: "/usergroup/master/:usergroup_id/edit",
    name: "usergroup-master-edit-page",
    component: UserGroupMasterEditPage
  },
  UserMasterShowPage: {
    path: "/user/master",
    name: "user-master-show-page",
    component: UserMasterShowPage
  },
  UserMasterCreatePage: {
    path: "/user/master/create",
    name: "user-master-create-page",
    component: UserMasterCreatePage
  },
  UserMasterEditPage: {
    path: "/user/master/:user_id/edit",
    name: "user-master-edit-page",
    component: UserMasterEditPage
  },
  WarningStopTimeShowPage: {
    path: "/stores/:store_id/warning_stop_time/:start_date/:end_date",
    name: "warning-stop-time-show-page",
    component: WarningStopTimeShowPage
  },
  WarningStopTimeEditPage: {
    path:
      "/stores/:store_id/warning_stop_time/:start_date/:end_date/:schedule_id/edit",
    name: "warning-stop-time-edit-page",
    component: WarningStopTimeEditPage
  },
  NotFoundPage: {
    path: "*",
    name: "not-found-page",
    component: NotFoundPage
  }
};

// パスパラメータの :id を引数で渡されたパラメータに書き換える
const replaceParams = (path: string, params: {}): string => {
  let replacedPath = path;
  Object.keys(params).forEach(k => {
    replacedPath = replacedPath.replace(`:${k}`, params[k]);
  });
  return replacedPath;
};

// allowedPaths 内に pathName が含まれているかどうかをチェックする
export const isAllowed = (
  pathName: string,
  allowedPaths: string[]
): boolean => {
  return allowedPaths.some(ap => ap === pathName);
};

// pageName にて指定されたページを返却する
// params の key を value に置き換える
export const getRoutePath = (pageName: string, params?: {}) => {
  if (!params) return routeInfos[pageName].path;
  return replaceParams(routeInfos[pageName].path, params);
};

// ルーティング情報を格納した変数
export const routes: RouteConfig[] = Object.keys(routeInfos).map(
  (v: string) => {
    return routeInfos[v] as RouteConfig;
  }
);
